import {Dialog, Transition} from '@headlessui/react';
import {Fragment} from 'react';
import crossIcon from '../../../assets/images/icons/cross.svg';

interface Props {
	success: boolean;
	setShowSuccess: (type: boolean) => void;
	message: string;
	desc: string;
	Okay: string;
}

const HelpModal = ({success, setShowSuccess, message, desc, Okay}: Props) => {
	const closeModal = () => {
		setShowSuccess(false);
	};
	return (
		<Transition appear show={success} as={Fragment}>
			<Dialog as='div' className='relative z-40' onClose={closeModal}>
				<Transition.Child
					as={Fragment}
					enter='ease-out duration-300'
					enterFrom='opacity-0'
					enterTo='opacity-100'
					// leave='ease-in duration-200'
					leaveFrom='opacity-100'
					leaveTo='opacity-0'
				>
					<div className='fixed inset-0 bg-black bg-opacity-25' />
				</Transition.Child>

				<div className='fixed inset-0 overflow-y-auto'>
					<div className='flex min-h-full items-center justify-center p-4 text-center'>
						<Transition.Child
							as={Fragment}
							enter='ease-out duration-300'
							enterFrom='opacity-0 scale-95'
							enterTo='opacity-100 scale-100'
							leave='ease-in duration-200'
							leaveFrom='opacity-100 scale-100'
							leaveTo='opacity-0 scale-95'
						>
							<Dialog.Panel className='w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all'>
								<div className='text-end mb-1'>
									<button onClick={closeModal}>
										<img src={crossIcon} alt='close modal' />
									</button>
								</div>
								<Dialog.Title as='h3' className='text-lg font-medium leading-6 text-gray-900 text-center'>
									{message}
								</Dialog.Title>
								<div className='text-center mt-5 mb-7'>
									<p>{desc}</p>
								</div>

								<div className='mt-4 flex justify-center gap-2'>
									<button
										type='button'
										className='bg-[#446AA4] py-3 px-6 rounded-[58px]  text-white text-base '
										onClick={closeModal}
									>
										{Okay}
									</button>
								</div>
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
		</Transition>
	);
};

export default HelpModal;
